import { combineReducers, createReducer, PayloadAction } from '@reduxjs/toolkit';

import { AgeCategory as ConfigurationAgeCategory, ConfigurationResult } from '@mews-distributor/data-access';
import { keyById } from '@mews/fp';
import { FETCH_CONFIGURATIONS_SUCCEEDED } from '../../configuration/actionTypes';
import { AgeCategory } from './types';

/*
 * @todo: Fix this type. RND-133663
 * OpenAPI  defines age category classification as a string, but we use enum in the FE.
 * After we update OpenAPI on BE, we can fix this type to not be a union:
 * ```ts
 * const dataInitialState: AgeCategories['data']
 * ```
 */
const dataInitialState: Record<string, ConfigurationAgeCategory | AgeCategory> = {};

const dataReducer = createReducer(dataInitialState, (builder) => {
    builder.addCase(
        FETCH_CONFIGURATIONS_SUCCEEDED,
        (
            state,
            { payload: { ageCategories } }: PayloadAction<ConfigurationResult, typeof FETCH_CONFIGURATIONS_SUCCEEDED>
        ) => ({
            ...state,
            ...keyById(ageCategories),
        })
    );
});

export const ageCategoriesReducer = combineReducers({
    data: dataReducer,
});
